import { useEffect, useRef } from "react";
import { useSelector } from "react-redux";

/**
 * Props:
 * - specificUrl: the app path you want to open (e.g., "/s/AR/Adjustments/loadBatchAdjustments")
 * - apiKey: Document360 widget API key
 * - pollingMs: how often to check for iframe readiness (default 500ms)
 */
export default function Document360Widget({ specificUrl, apiKey, pollingMs = 500 }) {
  const activeTab = useSelector((state) => state.activeTab.activeTab);
  const initializedRef = useRef(false);
  const articleClickedRef = useRef(false);
  const pollRef = useRef(null);

  // Example URL mapping
  const urlMapping = [
    {
      action: "Multiple",
      url: "/configuration/club",
      articles: [
        "c7947a15-8aa1-47ef-8317-d4ca26ba36cd",
        "4c2b0ee3-b5e0-4261-94ed-e9e584cc3970",
      ],
    },
     {
      action: "Multiple",
      url: "/configuration/score-penality-defs",
      articles: [
        "410fea69-7235-4a41-9662-2860e7198cf7",
        "356a0840-7240-42e4-9dde-728876ab6932",
      ],
    },
    // {
    //   action: "Single",
    //   url: "/configuration/HcDefs",
    //   articles: ["8d3533e0-687c-4e0c-9042-5f75fb0f344c"],
    // },
  ];

  // 1️⃣ Inject widget script once
  useEffect(() => {
    if (initializedRef.current) return;
    initializedRef.current = true;

    (function (w, d, s, o, f, js, fjs) {
      w["JS-Widget"] = o;
      w[o] =
        w[o] ||
        function () {
          (w[o].q = w[o].q || []).push(arguments);
        };
      js = d.createElement(s);
      fjs = d.getElementsByTagName(s)[0];
      js.id = o;
      js.src = f;
      js.async = true;
      fjs.parentNode.insertBefore(js, fjs);
    })(window, document, "script", "mw", "https://cdn.document360.io/static/js/widget.js");

    window.mw && window.mw("init", { apiKey });
  }, [apiKey]);

  // 2️⃣ Poll iframe until ready and call custom function
  useEffect(() => {
    articleClickedRef.current = false; // reset on tab change

    const getWidgetIframe = () => {
      const iframes = Array.from(document.querySelectorAll("iframe"));
      return (
        iframes.find(
          (f) =>
            (f.src && f.src.includes("document360")) ||
            f.className.includes("document360") ||
            f.id?.includes("document360-body-iframe")
        ) || null
      );
    };

    const tryOpenArticle = () => {
      if (articleClickedRef.current) return true;

      const iframe = getWidgetIframe();
      if (!iframe) return false;

      const fn = iframe.contentWindow?.openDocument360SingleArticalBasedOnMapping;
      if (typeof fn !== "function") return false;

      try {
        const doc360Obj = { widgetSetting: { url_mapping: urlMapping } };
        fn(specificUrl, activeTab, doc360Obj, iframe); // call your custom function
        articleClickedRef.current = true;
        return true;
      } catch (e) {
        console.warn("Failed to open Document360 article:", e);
        return false;
      }
    };

    // Poll until iframe + function ready
    pollRef.current = setInterval(() => {
      if (tryOpenArticle()) clearInterval(pollRef.current);
    }, pollingMs);

    return () => {
      if (pollRef.current) clearInterval(pollRef.current);
     
        // document.getElementById('close-window')?.click();
    
    };
  }, [activeTab, urlMapping, pollingMs, specificUrl]);

  // Component itself renders nothing; Document360 handles UI inside iframe
  return null;
}





// function Document360Widget({specificUrl}) {
//     const activeTab = useSelector((state) => state.activeTab.activeTab);
//   const pollRef = useRef(null);
//   const urlMapping = [
//     {
//       action: "Multiple",
//       url: "/configuration/club",
//       articles: [
//         "c7947a15-8aa1-47ef-8317-d4ca26ba36cd",
//         "4c2b0ee3-b5e0-4261-94ed-e9e584cc3970",
//       ],
//     },
//     {
//       action: "Single",
//       url: "/configuration/HcDefs",
//       articles: ["8d3533e0-687c-4e0c-9042-5f75fb0f344c"],
//     },
//     {
//       action: "Single",
//       url: "/configuration/score-point-defs",
//       articles: ["3bda6dcf-e70b-47f6-b2d7-3c2d4b779427"],
//     },
//   ];
//     useEffect(() => {
//         (function(w, d, s, o, f, js, fjs) {
//             w['JS-Widget'] = o;
//             w[o] = w[o] || function() { (w[o].q = w[o].q || []).push(arguments) };
//             js = d.createElement(s);
//             fjs = d.getElementsByTagName(s)[0];
//             js.id = o;
//             js.src = f;
//             js.async = 1;
//             fjs.parentNode.insertBefore(js, fjs);
//         })(window, document, 'script', 'mw', 'https://cdn.document360.io/static/js/widget.js');

//         window.mw && window.mw('init', { 
//             apiKey: 'g9S9cSkgviRFPxzNbQS92B84/BNAAs7hz6dJI5YDOXhxUFVg5d7i2b3hGG6WSmFIx9hTI1RohCJOG9SiVQyLousF86TPAYaCsmxVOlgIs7MiVnu4IAqGkVFinybKEEdyehKXx11yh/w7F/qQz854iA==' 
//         });
//     }, [activeTab, specificUrl]);

//     return null // This component doesn't render anything
// }

// export default Document360Widget;